import { AuditoriaBeanM } from "./auditoria_bean";

export class EstadoDml {
    c_estado:String;
	c_pk:String;
	x_tabla:String;
	x_param1:String;
	x_param2:String;
	x_param3:String;
}
export class EliminarDml {
  x_tabla:String;
  c_id:String;
  b_eliminado:String;
auditoriaBeanM:AuditoriaBeanM;
}
